<template lang="pug">
li
  .tag-entry
    icon.tiny(
      name="chevronDown",
      @click="toggleExpand",
      v-if="tag.children?.length && !expanded"
    )
    icon.tiny(
      name="chevronUp",
      @click="toggleExpand",
      v-if="tag.children?.length && expanded"
    )
    icon.tiny(name="next", v-if="!tag.children?.length")
    .selector(:class="tagClass(tag.id)", @click="toggle(tag)")
    span.tag-name {{ tag.name }}
  ul.child-list(style="list-style-type:none", v-if="tag.children && expanded")
    tag-node(
      v-for="child in tag.children",
      :key="child.id",
      :tag="child",
      :states="states",
      :mode="mode",
      @update="$emit('update', $event)"
    )
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import Icon from "@/components/Icon.vue";

export default {
  name: "TagNode",
  components: { Icon },
  props: {
    tag: Object,
    states: Object,
    mode: {
      type: String,
      default: "filter",
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    ...mapGetters({
      tagTree: "media/tagTree",
    }),
    isIncluded() {
      return this.include.includes(this.tag.id);
    },
    isExcluded() {
      return this.exclude.includes(this.tag.id);
    },
  },
  methods: {
    tagClass(id) {
      const state = this.states[id] || 0;
      if (state === 1) return "included";
      if (state === 2) return "excluded";
      return "neutral";
    },
    toggle(tag) {
      const id = tag.id;
      const current = this.states[id] || 0;
      const next = current >= 2 ? 0 : current + 1;
      this.$set(this.states, id, next);
      console.log('MODE: ', this.mode);
      if (this.mode === "filter") {
        // Kinder rekursiv aktualisieren
        const setChildren = (children) => {
          for (const child of children || []) {
            this.$set(this.states, child.id, next);
            setChildren(child.children);
          }
        };
        setChildren(tag.children);
      }
      console.log(
        "emit update",
        Object.keys(this.states).map((x) => `${x}: ${this.states[x]}`)
      );
      this.$emit("update", this.states);
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped lang="less">
.selector {
  width: 3.6vw;
  height: 3.6vw;
  border: 1px solid gray;
  border-radius: 50%;
}
.included {
  background: #80ff80;
}
.excluded {
  background: #ff8080;
}
.tag-entry {
  display: flex;
  align-items: center;
  margin: 0.1rem 0;
  gap: 2vw;

  .expand-toggle {
    width: 1em;
    display: inline-block;
    cursor: pointer;
  }

  .tag-name {
    flex: 1;
    text-align: left;
  }

  button {
    width: 1.5em;
    height: 1.5em;
    padding: 0;
    line-height: 1.2em;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-weight: bold;
    background: #eee;
    cursor: pointer;

    &.included {
      background: #cfc;
      border-color: #080;
    }

    &.excluded {
      background: #fbb;
      border-color: #800;
    }
  }

  ul.child-list {
    list-style-type: none;
    display: block;
  }
}
</style>
